import React from 'react';
export function Footer() {
  return <footer className="bg-brand-darker py-12 border-t border-brand-cardBorder" data-id="element-45">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 flex flex-col items-center text-center" data-id="element-46">
        <p className="text-xs sm:text-sm text-brand-muted/60 max-w-3xl mb-8 leading-relaxed" data-id="element-47">
          DESCARGO DE RESPONSABILIDAD: Este producto es de naturaleza
          informativa y educativa, y no sustituye el consejo, diagnóstico o
          tratamiento médico profesional. Consulta siempre a tu médico u otro
          proveedor de salud calificado antes de iniciar cualquier protocolo,
          dieta o régimen de suplementación. Los resultados pueden variar de
          persona a persona.
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-brand-muted/80 mb-6 font-medium" data-id="element-48">
          <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-49">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-50">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-51">
            Contacto
          </a>
        </div>

        <p className="text-xs text-brand-muted/50" data-id="element-52">
          &copy; {new Date().getFullYear()} El Código Maestro. Todos los
          derechos reservados.
        </p>
      </div>
    </footer>;
}